import { configureStore } from "@reduxjs/toolkit";
import filtersReducer from "./slices/filtersSlice";
import dashboardReducer from "./slices/dashboardSlice";
import uiReducer from "./slices/uiSlice";

// O Dashboard121Insights (v45) atualmente gerencia seu próprio estado
// internamente. Esta store é scaffolding para a futura migração — slices
// e thunks já estão prontos em src/store/slices/ e src/services/.
export const store = configureStore({
  reducer: {
    filters: filtersReducer,
    dashboard: dashboardReducer,
    ui: uiReducer,
  },
  devTools: import.meta.env.MODE !== "production",
});
